import React from 'react';
import { createRoot } from 'react-dom/client';
import Container from '../../src/event_details/container';
import { EventDetailsContextProvider } from '../../src/event_details/context/event_details.context';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';

document.addEventListener('DOMContentLoaded', (): void => {
  const container = document.getElementById('event-details-react-app');

  if (container) {
    const root = createRoot(container);

    root.render(
      <DevexHighOrderComponent>
        <EventDetailsContextProvider
          event={JSON.parse(container.dataset.event)}
        >
          <Container />
        </EventDetailsContextProvider>
      </DevexHighOrderComponent>
    );
  }
});
